import React from "react";
import { Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import PropTypes from "prop-types";
import {
  FormContainer,
  Description,
  Input,
  LongerStyledButton,
  StyledButton,
} from "./styles";
import HiddenCsrfInput from "./hidden_csrf_input";
import styled from "styled-components";
import PasswordStrengthBar from "@grnhse/seedling/lib/azalea/components/purgatory/password_strength_bar";

class SetupPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      passwordConfirmation: "",
    };
  }

  onChange = (event) => {
    this.setState({
      [event.target.dataset.stateName]: event.target.value.trim(),
    });
  };

  getButtonState = () => {
    return (
      this.state.password.length === 0 ||
      this.state.passwordConfirmation.length === 0
    );
  };

  render() {
    return (
      <FormContainer id="setup-password">
        <h2>Setup your password</h2>
        <Description>
          Create a password for <strong>{this.props.login}</strong>
        </Description>

        <form action={this.props.form_action_path} method="post">
          <HiddenCsrfInput />
          <input name="_method" type="hidden" value="put" />
          <input
            name="user[invite_token]"
            type="hidden"
            value={this.props.invite_token}
          />

          <FormGroup bsSize="large">
            <Input
              type="password"
              placeholder="New Password"
              aria-label="New Password"
              value={this.state.email}
              onChange={this.onChange}
              inputRef={(ref) => {
                this.input = ref;
              }}
              name="user[password]"
              data-state-name="password"
              autoFocus
              required
            />
            <StyledBar>
              <PasswordStrengthBar password={this.state.password} />
            </StyledBar>
          </FormGroup>

          <FormGroup bsSize="large">
            <Input
              type="password"
              placeholder="Confirm New Password"
              aria-label="Confirm New Password"
              value={this.state.email}
              onChange={this.onChange}
              name="user[password_confirmation]"
              data-state-name="passwordConfirmation"
              required
            />
          </FormGroup>

          <FormGroup>
            <LongerStyledButton type="submit" disabled={this.getButtonState()}>
              Set password
            </LongerStyledButton>
          </FormGroup>
        </form>
      </FormContainer>
    );
  }
}

const StyledBar = styled.div`
  margin: 0 auto;
  width: 98%;
`;

SetupPassword.propTypes = {
  form_action_path: PropTypes.string.isRequired,
  invite_token: PropTypes.string.isRequired,
  login: PropTypes.string.isRequired,
};

export default SetupPassword;
